import { useRouter } from 'next/router'

import type { ICompareAsesmenRefleksiPeriodResponse } from 'types/competency-profile'

interface IPeriodGuardChecker {
  periodData: ICompareAsesmenRefleksiPeriodResponse
  children?: JSX.Element
}

export const PERIOD_QUERY_PARAM = 'ended'

const PeriodGuardChecker = ({
  periodData,
  children,
}: IPeriodGuardChecker): JSX.Element => {
  const router = useRouter()
  if (!periodData.isEntryOpen) {
    router.replace(`/refleksi-kompetensi?${PERIOD_QUERY_PARAM}=true`)
    return null
  }
  return children
}

export default PeriodGuardChecker
